import { render, staticRenderFns } from "./ProBadge.vue?vue&type=template&id=3eae19f0"
import script from "./ProBadge.vue?vue&type=script&lang=js"
export * from "./ProBadge.vue?vue&type=script&lang=js"
import style0 from "./ProBadge.vue?vue&type=style&index=0&id=3eae19f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports